import { type ComponentProps, type FC } from "react";
import { A11y as CarouselA11y, Navigation as CarouselNavigation } from "swiper/modules";
import {
	type SwiperClass as CarouselClass,
	type SwiperProps as CarouselProps,
	type SwiperSlideProps as CarouselSlideProps,
	Swiper,
	SwiperSlide,
} from "swiper/react";
import { chakra } from "@chakra-ui/react";
import { Global } from "@emotion/react";
import swiperCss from "swiper/css?inline";
import swiperScrollBarCss from "swiper/css/scrollbar?inline";
import swiperA11yCss from "swiper/css/a11y?inline";
import swiperNavigationCss from "swiper/css/navigation?inline";

const ChakraSwiper = chakra<typeof Swiper, CarouselProps>(Swiper);
const Carousel: FC<ComponentProps<typeof ChakraSwiper>> = (props) => (
	<>
		<Global styles={swiperCss + swiperScrollBarCss + swiperA11yCss + swiperNavigationCss} />
		<ChakraSwiper {...props} />
	</>
)

const CarouselSlide = chakra<typeof SwiperSlide, CarouselSlideProps>(SwiperSlide);

// https://github.com/nolimits4web/swiper/issues/4413
CarouselSlide.displayName = "SwiperSlide";

export { Carousel, CarouselA11y, CarouselNavigation, CarouselSlide };
export type { CarouselClass, CarouselProps, CarouselSlideProps };

